/**
 * Web Push Notification Service
 * Delegates to platform-specific notification adapter
 */

import { getNotificationAdapter } from './platform';

/**
 * Check if push notifications are supported
 */
export function isPushSupported(): boolean {
  return getNotificationAdapter().isSupported();
}

/**
 * Get current push subscription state
 */
export async function isPushSubscribed(): Promise<boolean> {
  return getNotificationAdapter().isSubscribed();
}

/**
 * Subscribe to push notifications
 */
export async function subscribeToPush(): Promise<boolean> {
  return getNotificationAdapter().subscribe();
}

/**
 * Unsubscribe from push notifications
 */
export async function unsubscribeFromPush(): Promise<boolean> {
  return getNotificationAdapter().unsubscribe();
}
